module.exports = __webpack_public_path__ + "static/img/seb2.e1c6e9a4.png";